'use client'

import { useEffect, useState } from 'react'
import { Analytics } from '@cerifi/analytics'
import { BCProduct } from '@cerifi/ecomm/bigcommerce/types/product'
import { Card } from '@cerifi/ui/components/card'
import { Container } from '@cerifi/ui/components/container'
import { Divider } from '@cerifi/ui/components/divider'

import { EnrollmentFooter } from '@/components/enrollment/enrollment-footer'
import { EnrollmentHeader } from '@/components/enrollment/enrollment-header'
import { EnrollmentMainCard } from '@/components/enrollment/enrollment-main-card'
import { EnrollmentDobPicker } from '../enrollment-dob-picker'
import { EnrollmentInstructorLedMonthPicker } from '../enrollment-instructor-led-month-picker'
import { EnrollmentTextbookAddon } from '../enrollment-textbook-addon'
import { UniversityEnrollmentPicker } from '../enrollment-university-picker'

interface InstructorLed {
  eBook: BCProduct
  eBookPro: BCProduct
  textBookAddOn: BCProduct
  /** Used to compare to the ebookPro price to determine the discount (ebookPro is a bundle of the dalton review plus + the original ebook under one sku ) */
  originalDaltonReviewPlus: BCProduct
}

export const CfpInstructorLed = (props: InstructorLed) => {
  const [product, setProduct] = useState(props.eBookPro)
  const [isPro, setIsPro] = useState(true)
  const [addText, setAddText] = useState(false)

  /** User is switching to add The Dalton Review or remove it */
  const changeProduct = (isPro: boolean) => {
    setIsPro(isPro)
    setProduct(isPro ? props.eBookPro : props.eBook)
  }

  useEffect(() => {
    if (product) {
      Analytics.ViewItem(product.id, product.sku, product.name, product.price)
    }
  }, [product])

  return (
    <>
      <Container className="pb-20">
        <EnrollmentHeader tag="CFP Education Program" />

        <EnrollmentMainCard
          title="Instructor-Led Online"
          tag="CFP EDUCATION PROGRAM"
          innerTags={['CFP EXAM PREP', 'MONEY-BACK GUARANTEE']}
          text="The Dalton Review is a comprehensive review program developed by former CFP® Board of Examiners members, designed to prepare students to pass the CFP® exam."
          price={props.eBook.price}
          guaranteeToPass
          checkedPro={isPro}
          checkedProChange={(c) => changeProduct(c)}
          allowPaymentPlans={true}
          plusPrice={
            /** EbookPro is a bundle under one sku of the eBook and The Dalton Review Plus.
             *  This is showing just the price to add the Dalton Review Plus */
            props.eBookPro.price - props.eBook.price
          }
          originalPlusPrice={props.originalDaltonReviewPlus.price}
        />

        <div className="sm:mb-20">
          <h3 className="mt-12 text-2xl">Enroll in Your Course</h3>

          <Card className="mt-6">
            <EnrollmentTextbookAddon
              product={props.textBookAddOn}
              checked={addText}
              onCheckedChange={(v) => setAddText(v)}
            />
            <Divider className="my-6" />
            <EnrollmentInstructorLedMonthPicker product={product} />
            <UniversityEnrollmentPicker />
            <EnrollmentDobPicker />
          </Card>
        </div>
      </Container>

      <EnrollmentFooter
        hasUniversity
        hasMonth
        tag="CFP Education"
        title="Instructor-Led Online"
        product={product}
        addOnProduct={addText ? props.textBookAddOn : null}
      />
    </>
  )
}
